// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"79e4268d","651":"a3251b2f","858":"2a1f93a0"}[chunkId] + ".chunk.js";
};